/* global modForm */
import { formSubmitCallback } from '../../../helpers';
/**
 * Handles form (step) submission & validations
 * @param {boolean} [addEvent=true] - Determines whether to add event listener
 */
export function initFormSubmit(addEvent = true) {
	const form = modForm.opts.form;
	let zipFormElementsToSync = [];
	const shouldSyncMultipleZipForms = modForm.opts.zipFormSelectorsToSync.length;
	if (shouldSyncMultipleZipForms) {
		zipFormElementsToSync = document.querySelectorAll(modForm.opts.zipFormSelectorsToSync);
	}

	if (addEvent) {
		form.addEventListener('submit', formSubmitCallback);
		if (shouldSyncMultipleZipForms) {
			zipFormElementsToSync.forEach(formEle => {
				formEle.addEventListener('submit', modForm.formSubmitCallback);
			});
		}
	} else {
		form.removeEventListener('submit', formSubmitCallback);
		if (shouldSyncMultipleZipForms) {
			zipFormElementsToSync.forEach(formEle => {
				formEle.removeEventListener('submit', formSubmitCallback);
			});
		}
	}
}
